(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global = global || self, global.AngularJSHelpViewer = factory());
}(this, (function () { 'use strict';

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function unwrapExports (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	var helpViewer = createCommonjsModule(function (module, exports) {
	(function (global, factory) {
	   factory(exports) ;
	}(commonjsGlobal, (function (exports) {
	  function _typeof(obj) {
	    "@babel/helpers - typeof";

	    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	      _typeof = function (obj) {
	        return typeof obj;
	      };
	    } else {
	      _typeof = function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	      };
	    }

	    return _typeof(obj);
	  }

	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }

	    return obj;
	  }

	  function noop() {}

	  function assign(tar, src) {
	    for (var k in src) {
	      tar[k] = src[k];
	    }

	    return tar;
	  }

	  function assignTrue(tar, src) {
	    for (var k in src) {
	      tar[k] = 1;
	    }

	    return tar;
	  }

	  function run(fn) {
	    fn();
	  }

	  function append(target, node) {
	    target.appendChild(node);
	  }

	  function insert(target, node, anchor) {
	    target.insertBefore(node, anchor);
	  }

	  function detachNode(node) {
	    node.parentNode.removeChild(node);
	  }

	  function detachBetween(before, after) {
	    while (before.nextSibling && before.nextSibling !== after) {
	      before.parentNode.removeChild(before.nextSibling);
	    }
	  }

	  function createElement(name) {
	    return document.createElement(name);
	  }

	  function createText(data) {
	    return document.createTextNode(data);
	  }

	  function addListener(node, event, handler, options) {
	    node.addEventListener(event, handler, options);
	  }

	  function removeListener(node, event, handler, options) {
	    node.removeEventListener(event, handler, options);
	  }

	  function setData(text, data) {
	    text.data = '' + data;
	  }

	  function linear(t) {
	    return t;
	  }

	  function generateRule(_ref, ease, fn) {
	    var a = _ref.a,
	        b = _ref.b,
	        delta = _ref.delta,
	        duration = _ref.duration;
	    var step = 16.666 / duration;
	    var keyframes = '{\n';

	    for (var p = 0; p <= 1; p += step) {
	      var t = a + delta * ease(p);
	      keyframes += p * 100 + "%{".concat(fn(t, 1 - t), "}\n");
	    }

	    return keyframes + "100% {".concat(fn(b, 1 - b), "}\n}");
	  } // https://github.com/darkskyapp/string-hash/blob/master/index.js


	  function hash(str) {
	    var hash = 5381;
	    var i = str.length;

	    while (i--) {
	      hash = (hash << 5) - hash ^ str.charCodeAt(i);
	    }

	    return hash >>> 0;
	  }

	  function wrapTransition(component, node, fn, params, intro) {
	    var obj = fn.call(component, node, params);
	    var duration;
	    var ease;
	    var cssText;
	    var initialised = false;
	    return {
	      t: intro ? 0 : 1,
	      running: false,
	      program: null,
	      pending: null,
	      run: function run(b, callback) {
	        var _this = this;

	        if (typeof obj === 'function') {
	          transitionManager.wait().then(function () {
	            obj = obj();

	            _this._run(b, callback);
	          });
	        } else {
	          this._run(b, callback);
	        }
	      },
	      _run: function _run(b, callback) {
	        duration = obj.duration || 300;
	        ease = obj.easing || linear;
	        var program = {
	          start: window.performance.now() + (obj.delay || 0),
	          b: b,
	          callback: callback || noop
	        };

	        if (intro && !initialised) {
	          if (obj.css && obj.delay) {
	            cssText = node.style.cssText;
	            node.style.cssText += obj.css(0, 1);
	          }

	          if (obj.tick) obj.tick(0, 1);
	          initialised = true;
	        }

	        if (!b) {
	          program.group = outros.current;
	          outros.current.remaining += 1;
	        }

	        if (obj.delay) {
	          this.pending = program;
	        } else {
	          this.start(program);
	        }

	        if (!this.running) {
	          this.running = true;
	          transitionManager.add(this);
	        }
	      },
	      start: function start(program) {
	        component.fire("".concat(program.b ? 'intro' : 'outro', ".start"), {
	          node: node
	        });
	        program.a = this.t;
	        program.delta = program.b - program.a;
	        program.duration = duration * Math.abs(program.b - program.a);
	        program.end = program.start + program.duration;

	        if (obj.css) {
	          if (obj.delay) node.style.cssText = cssText;
	          var rule = generateRule(program, ease, obj.css);
	          transitionManager.addRule(rule, program.name = '__svelte_' + hash(rule));
	          node.style.animation = (node.style.animation || '').split(', ').filter(function (anim) {
	            return anim && (program.delta < 0 || !/__svelte/.test(anim));
	          }).concat("".concat(program.name, " ").concat(program.duration, "ms linear 1 forwards")).join(', ');
	        }

	        this.program = program;
	        this.pending = null;
	      },
	      update: function update(now) {
	        var program = this.program;
	        if (!program) return;
	        var p = now - program.start;
	        this.t = program.a + program.delta * ease(p / program.duration);
	        if (obj.tick) obj.tick(this.t, 1 - this.t);
	      },
	      done: function done() {
	        var program = this.program;
	        this.t = program.b;
	        if (obj.tick) obj.tick(this.t, 1 - this.t);
	        component.fire("".concat(program.b ? 'intro' : 'outro', ".end"), {
	          node: node
	        });

	        if (!program.b && !program.invalidated) {
	          program.group.callbacks.push(function () {
	            program.callback();
	            if (obj.css) transitionManager.deleteRule(node, program.name);
	          });

	          if (--program.group.remaining === 0) {
	            program.group.callbacks.forEach(run);
	          }
	        } else {
	          if (obj.css) transitionManager.deleteRule(node, program.name);
	        }

	        this.running = !!this.pending;
	      },
	      abort: function abort(reset) {
	        if (this.program) {
	          if (reset && obj.tick) obj.tick(1, 0);
	          if (obj.css) transitionManager.deleteRule(node, this.program.name);
	          this.program = this.pending = null;
	          this.running = false;
	        }
	      },
	      invalidate: function invalidate() {
	        if (this.program) {
	          this.program.invalidated = true;
	        }
	      }
	    };
	  }

	  var outros = {};

	  function groupOutros() {
	    outros.current = {
	      remaining: 0,
	      callbacks: []
	    };
	  }

	  var transitionManager = {
	    running: false,
	    transitions: [],
	    bound: null,
	    stylesheet: null,
	    activeRules: {},
	    promise: null,
	    add: function add(transition) {
	      this.transitions.push(transition);

	      if (!this.running) {
	        this.running = true;
	        requestAnimationFrame(this.bound || (this.bound = this.next.bind(this)));
	      }
	    },
	    addRule: function addRule(rule, name) {
	      if (!this.stylesheet) {
	        var style = createElement('style');
	        document.head.appendChild(style);
	        transitionManager.stylesheet = style.sheet;
	      }

	      if (!this.activeRules[name]) {
	        this.activeRules[name] = true;
	        this.stylesheet.insertRule("@keyframes ".concat(name, " ").concat(rule), this.stylesheet.cssRules.length);
	      }
	    },
	    next: function next() {
	      this.running = false;
	      var now = window.performance.now();
	      var i = this.transitions.length;

	      while (i--) {
	        var transition = this.transitions[i];

	        if (transition.program && now >= transition.program.end) {
	          transition.done();
	        }

	        if (transition.pending && now >= transition.pending.start) {
	          transition.start(transition.pending);
	        }

	        if (transition.running) {
	          transition.update(now);
	          this.running = true;
	        } else if (!transition.pending) {
	          this.transitions.splice(i, 1);
	        }
	      }

	      if (this.running) {
	        requestAnimationFrame(this.bound);
	      } else if (this.stylesheet) {
	        var _i = this.stylesheet.cssRules.length;

	        while (_i--) {
	          this.stylesheet.deleteRule(_i);
	        }

	        this.activeRules = {};
	      }
	    },
	    deleteRule: function deleteRule(node, name) {
	      node.style.animation = node.style.animation.split(', ').filter(function (anim) {
	        return anim && anim.indexOf(name) === -1;
	      }).join(', ');
	    },
	    wait: function wait() {
	      if (!transitionManager.promise) {
	        transitionManager.promise = Promise.resolve();
	        transitionManager.promise.then(function () {
	          transitionManager.promise = null;
	        });
	      }

	      return transitionManager.promise;
	    }
	  };

	  function blankObject() {
	    return Object.create(null);
	  }

	  function destroy(detach) {
	    this.destroy = noop;
	    this.fire('destroy');
	    this.set = noop;

	    this._fragment.d(detach !== false);

	    this._fragment = null;
	    this._state = {};
	  }

	  function _differs(a, b) {
	    return a != a ? b == b : a !== b || a && _typeof(a) === 'object' || typeof a === 'function';
	  }

	  function _differsImmutable(a, b) {
	    return a != a ? b == b : a !== b;
	  }

	  function fire(eventName, data) {
	    var handlers = eventName in this._handlers && this._handlers[eventName].slice();

	    if (!handlers) return;

	    for (var i = 0; i < handlers.length; i += 1) {
	      var handler = handlers[i];

	      if (!handler.__calling) {
	        try {
	          handler.__calling = true;
	          handler.call(this, data);
	        } finally {
	          handler.__calling = false;
	        }
	      }
	    }
	  }

	  function flush(component) {
	    component._lock = true;
	    callAll(component._beforecreate);
	    callAll(component._oncreate);
	    callAll(component._aftercreate);
	    component._lock = false;
	  }

	  function get() {
	    return this._state;
	  }

	  function init(component, options) {
	    component._handlers = blankObject();
	    component._slots = blankObject();
	    component._bind = options._bind;
	    component._staged = {};
	    component.options = options;
	    component.root = options.root || component;
	    component.store = options.store || component.root.store;

	    if (!options.root) {
	      component._beforecreate = [];
	      component._oncreate = [];
	      component._aftercreate = [];
	    }
	  }

	  function on(eventName, handler) {
	    var handlers = this._handlers[eventName] || (this._handlers[eventName] = []);
	    handlers.push(handler);
	    return {
	      cancel: function cancel() {
	        var index = handlers.indexOf(handler);
	        if (~index) handlers.splice(index, 1);
	      }
	    };
	  }

	  function set(newState) {
	    this._set(assign({}, newState));

	    if (this.root._lock) return;
	    flush(this.root);
	  }

	  function _set(newState) {
	    var oldState = this._state,
	        changed = {},
	        dirty = false;
	    newState = assign(this._staged, newState);
	    this._staged = {};

	    for (var key in newState) {
	      if (this._differs(newState[key], oldState[key])) changed[key] = dirty = true;
	    }

	    if (!dirty) return;
	    this._state = assign(assign({}, oldState), newState);

	    this._recompute(changed, this._state);

	    if (this._bind) this._bind(changed, this._state);

	    if (this._fragment) {
	      this.fire("state", {
	        changed: changed,
	        current: this._state,
	        previous: oldState
	      });

	      this._fragment.p(changed, this._state);

	      this.fire("update", {
	        changed: changed,
	        current: this._state,
	        previous: oldState
	      });
	    }
	  }

	  function _stage(newState) {
	    assign(this._staged, newState);
	  }

	  function callAll(fns) {
	    while (fns && fns.length) {
	      fns.shift()();
	    }
	  }

	  function _mount(target, anchor) {
	    this._fragment[this._fragment.i ? 'i' : 'm'](target, anchor || null);
	  }

	  var proto = {
	    destroy: destroy,
	    get: get,
	    fire: fire,
	    on: on,
	    set: set,
	    _recompute: noop,
	    _set: _set,
	    _stage: _stage,
	    _mount: _mount,
	    _differs: _differs
	  };

	  function unwrapExports (x) {
	  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	  }

	  function createCommonjsModule(fn, module) {
	  	return module = { exports: {} }, fn(module, module.exports), module.exports;
	  }

	  /*! *****************************************************************************
	  Copyright (c) Microsoft Corporation. All rights reserved.
	  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	  this file except in compliance with the License. You may obtain a copy of the
	  License at http://www.apache.org/licenses/LICENSE-2.0

	  THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	  KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	  WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	  MERCHANTABLITY OR NON-INFRINGEMENT.

	  See the Apache Version 2.0 License for specific language governing permissions
	  and limitations under the License.
	  ***************************************************************************** */
	  /* global Reflect, Promise */

	  var extendStatics = function(d, b) {
	      extendStatics = Object.setPrototypeOf ||
	          ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	          function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	      return extendStatics(d, b);
	  };

	  function __extends(d, b) {
	      extendStatics(d, b);
	      function __() { this.constructor = d; }
	      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	  }

	  var __assign = function() {
	      __assign = Object.assign || function __assign(t) {
	          for (var s, i = 1, n = arguments.length; i < n; i++) {
	              s = arguments[i];
	              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	          }
	          return t;
	      };
	      return __assign.apply(this, arguments);
	  };

	  function __rest(s, e) {
	      var t = {};
	      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	          t[p] = s[p];
	      if (s != null && typeof Object.getOwnPropertySymbols === "function")
	          for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	              if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                  t[p[i]] = s[p[i]];
	          }
	      return t;
	  }

	  function __decorate(decorators, target, key, desc) {
	      var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	      if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	      else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	      return c > 3 && r && Object.defineProperty(target, key, r), r;
	  }

	  function __param(paramIndex, decorator) {
	      return function (target, key) { decorator(target, key, paramIndex); }
	  }

	  function __metadata(metadataKey, metadataValue) {
	      if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	  }

	  function __awaiter(thisArg, _arguments, P, generator) {
	      function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	      return new (P || (P = Promise))(function (resolve, reject) {
	          function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	          function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	          function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	          step((generator = generator.apply(thisArg, _arguments || [])).next());
	      });
	  }

	  function __generator(thisArg, body) {
	      var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	      return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	      function verb(n) { return function (v) { return step([n, v]); }; }
	      function step(op) {
	          if (f) throw new TypeError("Generator is already executing.");
	          while (_) try {
	              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	              if (y = 0, t) op = [op[0] & 2, t.value];
	              switch (op[0]) {
	                  case 0: case 1: t = op; break;
	                  case 4: _.label++; return { value: op[1], done: false };
	                  case 5: _.label++; y = op[1]; op = [0]; continue;
	                  case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                  default:
	                      if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                      if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                      if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                      if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                      if (t[2]) _.ops.pop();
	                      _.trys.pop(); continue;
	              }
	              op = body.call(thisArg, _);
	          } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	          if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	      }
	  }

	  function __exportStar(m, exports) {
	      for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	  }

	  function __values(o) {
	      var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	      if (m) return m.call(o);
	      if (o && typeof o.length === "number") return {
	          next: function () {
	              if (o && i >= o.length) o = void 0;
	              return { value: o && o[i++], done: !o };
	          }
	      };
	      throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	  }

	  function __read(o, n) {
	      var m = typeof Symbol === "function" && o[Symbol.iterator];
	      if (!m) return o;
	      var i = m.call(o), r, ar = [], e;
	      try {
	          while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	      }
	      catch (error) { e = { error: error }; }
	      finally {
	          try {
	              if (r && !r.done && (m = i["return"])) m.call(i);
	          }
	          finally { if (e) throw e.error; }
	      }
	      return ar;
	  }

	  function __spread() {
	      for (var ar = [], i = 0; i < arguments.length; i++)
	          ar = ar.concat(__read(arguments[i]));
	      return ar;
	  }

	  function __spreadArrays() {
	      for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	      for (var r = Array(s), k = 0, i = 0; i < il; i++)
	          for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	              r[k] = a[j];
	      return r;
	  }
	  function __await(v) {
	      return this instanceof __await ? (this.v = v, this) : new __await(v);
	  }

	  function __asyncGenerator(thisArg, _arguments, generator) {
	      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	      var g = generator.apply(thisArg, _arguments || []), i, q = [];
	      return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	      function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	      function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	      function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
	      function fulfill(value) { resume("next", value); }
	      function reject(value) { resume("throw", value); }
	      function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	  }

	  function __asyncDelegator(o) {
	      var i, p;
	      return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	      function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	  }

	  function __asyncValues(o) {
	      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	      var m = o[Symbol.asyncIterator], i;
	      return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	      function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	      function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	  }

	  function __makeTemplateObject(cooked, raw) {
	      if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	      return cooked;
	  }
	  function __importStar(mod) {
	      if (mod && mod.__esModule) return mod;
	      var result = {};
	      if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	      result.default = mod;
	      return result;
	  }

	  function __importDefault(mod) {
	      return (mod && mod.__esModule) ? mod : { default: mod };
	  }

	  function __classPrivateFieldGet(receiver, privateMap) {
	      if (!privateMap.has(receiver)) {
	          throw new TypeError("attempted to get private field on non-instance");
	      }
	      return privateMap.get(receiver);
	  }

	  function __classPrivateFieldSet(receiver, privateMap, value) {
	      if (!privateMap.has(receiver)) {
	          throw new TypeError("attempted to set private field on non-instance");
	      }
	      privateMap.set(receiver, value);
	      return value;
	  }

	  var tslib_es6 = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    __extends: __extends,
	    get __assign () { return __assign; },
	    __rest: __rest,
	    __decorate: __decorate,
	    __param: __param,
	    __metadata: __metadata,
	    __awaiter: __awaiter,
	    __generator: __generator,
	    __exportStar: __exportStar,
	    __values: __values,
	    __read: __read,
	    __spread: __spread,
	    __spreadArrays: __spreadArrays,
	    __await: __await,
	    __asyncGenerator: __asyncGenerator,
	    __asyncDelegator: __asyncDelegator,
	    __asyncValues: __asyncValues,
	    __makeTemplateObject: __makeTemplateObject,
	    __importStar: __importStar,
	    __importDefault: __importDefault,
	    __classPrivateFieldGet: __classPrivateFieldGet,
	    __classPrivateFieldSet: __classPrivateFieldSet
	  });

	  var Cache_1 = createCommonjsModule(function (module, exports) {
	  Object.defineProperty(exports, "__esModule", { value: true });
	  /**
	   * Simple cache implementation
	   */
	  var Cache = /** @class */ (function () {
	      function Cache() {
	          this.data = {};
	          this.pending = {};
	      }
	      Cache.prototype.put = function (key, value) {
	          var previousValue = this.data[key];
	          this.data[key] = value;
	          return previousValue;
	      };
	      Cache.prototype.get = function (key) {
	          return this.data[key];
	      };
	      Cache.prototype.remove = function (key) {
	          var previousValue = this.data[key];
	          delete this.data[key];
	          return previousValue;
	      };
	      Cache.prototype.removeAll = function () {
	          this.data = {};
	      };
	      /**
	       * Gets a value from the cache or invokes the callback to populate the value
	       * with the result of a promise. If invoked multiple times, it will return the promise
	       * of the first pending invocation, preventing multiple invocations while a promise is resolving.
	       *
	       * @param key cache key
	       * @param callback returns a Promise to populate the cache with
	       * @returns Promise<*> a promise with the cached value
	       */
	      Cache.prototype.refreshIfAbsent = function (key, callback) {
	          if (this.data.hasOwnProperty(key)) {
	              return Promise.resolve(this.data[key]);
	          }
	          return this.refresh(key, callback);
	      };
	      /**
	       * Invokes the callback to populate the value with the result of a promise.
	       * If invoked multiple times, it will return the promise
	       * of the first pending invocation, preventing multiple invocations while a promise is resolving.
	       *
	       * @param key cache key
	       * @param callback returns a Promise to populate the cache with
	       * @returns Promise<*> a promise with the cached value
	       */
	      Cache.prototype.refresh = function (key, callback) {
	          var _this = this;
	          // Check if the callback is already pending for this key
	          var pending = this.pending[key];
	          if (pending) {
	              return pending;
	          }
	          pending = callback();
	          this.pending[key] = pending;
	          return pending.then(function (value) {
	              delete _this.pending[key];
	              _this.put(key, value);
	              return value;
	          });
	      };
	      return Cache;
	  }());
	  exports.default = Cache;

	  });

	  unwrapExports(Cache_1);

	  var Registry_1 = createCommonjsModule(function (module, exports) {
	  Object.defineProperty(exports, "__esModule", { value: true });

	  var Cache_1$1 = tslib_es6.__importDefault(Cache_1);
	  exports.SERVICE_REGISTRY_PATH = '/api/portal/v1/client/config';
	  var PORTAL_SERVICE_NAME = 'portal_service';
	  var PORTAL_CLIENT_CONFIG_PATH = 'client/config';
	  var DEFAULT_CONFIG = {
	      host: '',
	      cache: new Cache_1$1.default(),
	  };
	  var Registry = /** @class */ (function () {
	      function Registry(config) {
	          if (config === void 0) { config = DEFAULT_CONFIG; }
	          this.config = tslib_es6.__assign(tslib_es6.__assign({}, DEFAULT_CONFIG), config);
	      }
	      // Get the underlying registry cache
	      Registry.prototype.getCache = function () {
	          return this.config.cache;
	      };
	      Registry.prototype.getRegistry = function () {
	          var _this = this;
	          return this.config.cache.refreshIfAbsent('registry', function () {
	              var serviceRegistryUrl = _this.getHost();
	              serviceRegistryUrl += exports.SERVICE_REGISTRY_PATH;
	              var config = {
	                  method: 'GET',
	                  mode: 'cors',
	                  credentials: 'include',
	                  headers: {
	                      'Content-Type': 'application/json',
	                  },
	              };
	              return fetch(serviceRegistryUrl, config).then(function (resp) {
	                  if (!resp.ok) {
	                      return Promise.reject(resp);
	                  }
	                  return resp.json().then(function (data) {
	                      var dataResponse = tslib_es6.__assign({ data: data }, resp);
	                      var registry = data.registry;
	                      // Optimization - also stuff the client config URL into the cache.
	                      // Sometimes, this URL can be different if it's requested from the same domain.
	                      var portalService = registry.services[PORTAL_SERVICE_NAME];
	                      if (portalService) {
	                          var clientConfigUrl = _this.createServiceUrl(portalService, PORTAL_CLIENT_CONFIG_PATH);
	                          _this.config.cache.put(clientConfigUrl, dataResponse);
	                      }
	                      return dataResponse;
	                  });
	              });
	          }).then(function (resp) {
	              return resp.data.registry;
	          });
	      };
	      Registry.prototype.getUrl = function (serviceName, path, version) {
	          var _this = this;
	          if (path === void 0) { path = ''; }
	          return this.getRegistry().then(function (data) {
	              var service = data.services[serviceName];
	              if (service === undefined) {
	                  throw new Error("Unable to find service '" + serviceName + "'");
	              }
	              return service;
	          }).then(function (service) {
	              return _this.createServiceUrl(service, path, version);
	          });
	      };
	      Registry.prototype.getServiceBaseUrl = function (service, version) {
	          var baseUrl = service.base_sv_url;
	          if (!baseUrl) {
	              // unversioned service - simply return regular service url
	              return service.sv_url;
	          }
	          if (version === undefined) {
	              // Use configured version if present
	              // if(apiVersions[serviceName]) {
	              //  version = apiVersions[serviceName];
	              // Fallback to version 1 (keeps backwards comparability and generally safe)
	              version = 1;
	          }
	          return this.joinUrlParts(baseUrl, 'v' + version);
	      };
	      Registry.prototype.getServiceHostUrl = function (service) {
	          // Inspired by https://gist.github.com/jlong/2428561
	          var parser = document.createElement('a');
	          parser.href = service.sv_url;
	          return parser.protocol + "//" + parser.host;
	      };
	      Registry.prototype.createServiceUrl = function (service, path, version) {
	          var base;
	          if (path.charAt(0) === '/') {
	              // Host absolute URL
	              base = this.getServiceHostUrl(service);
	          }
	          else {
	              // Service relative URL
	              base = this.getServiceBaseUrl(service, version);
	          }
	          return this.joinUrlParts(base, path);
	      };
	      /**
	       * Determines the registry host in the following order,
	       * 1. Uses the configured host if set
	       * 2. If a PrintOS subdomain is detected as the current hostname,
	       *    the base domain is returned.
	       *    For example, if location.hostname is 'app.www.printos.com',
	       *    then 'www.printos.com' is returned.
	       * 3. Return an empty string otherwise (resulting in a registry call relative
	       *    to the current host).
	       */
	      Registry.prototype.getHost = function () {
	          if (this.config.host) {
	              // Ensure https
	              if (this.config.host.indexOf('https://') !== 0) {
	                  this.config.host = 'https://' + this.config.host;
	              }
	              return this.config.host;
	          }
	          return '';
	      };
	      Registry.prototype.joinUrlParts = function (a, b) {
	          if (!b) {
	              return a;
	          }
	          if (b.charAt(0) === '/') {
	              // Prevent double slashes by ensuring part b doesn't have a slash
	              b = b.substr(1);
	          }
	          if (a.charAt(a.length - 1) === '/') {
	              return a + b;
	          }
	          return a + '/' + b;
	      };
	      return Registry;
	  }());
	  exports.default = Registry;

	  });

	  unwrapExports(Registry_1);
	  var Registry_2 = Registry_1.SERVICE_REGISTRY_PATH;

	  var Http_1 = createCommonjsModule(function (module, exports) {
	  Object.defineProperty(exports, "__esModule", { value: true });

	  var Registry_1$1 = tslib_es6.__importDefault(Registry_1);
	  var DEFAULT_CONFIG = {
	      registry: new Registry_1$1.default(),
	  };
	  var Http = /** @class */ (function () {
	      function Http(config) {
	          if (config === void 0) { config = DEFAULT_CONFIG; }
	          this.config = tslib_es6.__assign(tslib_es6.__assign({}, DEFAULT_CONFIG), config);
	          // Use registry cache by default to cache the registry efficiently
	          this.config.cache = this.config.cache || this.config.registry.getCache();
	      }
	      Http.prototype.fetchJsonResponse = function (config) {
	          var _this = this;
	          var url = Http.formatUrl(config);
	          var fetchConfig = {
	              method: config.method,
	              mode: 'cors',
	              credentials: config.credentials ? config.credentials : 'include',
	              headers: {},
	          };
	          if (config.data !== undefined && config.data !== null) {
	              if (config.data instanceof FormData) {
	                  fetchConfig.body = config.data;
	                  // fetchConfig.headers['Content-Type'] = 'multipart/form-data';
	              }
	              else {
	                  fetchConfig.body = JSON.stringify(config.data);
	                  fetchConfig.headers['Content-Type'] = 'application/json';
	              }
	          }
	          return fetch(url, fetchConfig).then(function (resp) {
	              if (_this.responseInterceptor) {
	                  return _this.responseInterceptor(resp, config);
	              }
	              return resp;
	          }).then(function (resp) {
	              if (!resp.ok) {
	                  return Promise.reject(Object.assign(resp, { data: null }));
	              }
	              if (resp.status === 204) {
	                  return Promise.resolve(Object.assign(resp, { data: null }));
	              }
	              var contentType = resp.headers.get('Content-Type');
	              if (contentType === 'text/plain' || config.responseType === 'text') {
	                  return resp.text().then(function (data) {
	                      // Extend response to include data
	                      return Object.assign(resp, { data: data });
	                  });
	              }
	              return resp.json().then(function (data) {
	                  // Extend response to include data
	                  return Object.assign(resp, { data: data });
	              });
	          });
	      };
	      Http.formatUrl = function (config) {
	          var url = config.url;
	          if (config.params) {
	              if (url.includes('?')) {
	                  url += '&';
	              }
	              else {
	                  url += '?';
	              }
	              url += Http.getQueryString(config.params);
	          }
	          return url;
	      };
	      // Adapted from https://github.com/github/fetch/issues/256#issuecomment-271870897
	      Http.getQueryString = function (params) {
	          return Object.keys(params).map(function (k) {
	              var param = params[k];
	              if (Array.isArray(param)) {
	                  return param
	                      .map(function (val) { return encodeURIComponent(k) + "=" + encodeURIComponent(val); })
	                      .join('&');
	              }
	              return encodeURIComponent(k) + "=" + encodeURIComponent(param);
	          }).join('&');
	      };
	      Http.prototype.request = function (config) {
	          var _this = this;
	          if (config === void 0) { config = {}; }
	          if (config.cache === true) {
	              return this.config.cache.refreshIfAbsent(Http.formatUrl(config), function () {
	                  return _this.fetchJsonResponse(config);
	              });
	          }
	          if (config.cache === 'refresh') {
	              return this.config.cache.refresh(Http.formatUrl(config), function () {
	                  return _this.fetchJsonResponse(config);
	              });
	          }
	          return this.fetchJsonResponse(config);
	      };
	      Http.prototype.serviceRequest = function (serviceName, path, config) {
	          var _this = this;
	          if (config === void 0) { config = {}; }
	          return this.config.registry.getUrl(serviceName, path, config.version).then(function (url) {
	              config.url = url;
	              return _this.request(config);
	          });
	      };
	      //
	      // Shortcut methods
	      //
	      Http.prototype.get = function (serviceName, path, config) {
	          if (config === void 0) { config = {}; }
	          config.method = 'GET';
	          return this.serviceRequest(serviceName, path, config);
	      };
	      Http.prototype.post = function (serviceName, path, data, config) {
	          if (config === void 0) { config = {}; }
	          config.method = 'POST';
	          config.data = data;
	          return this.serviceRequest(serviceName, path, config);
	      };
	      Http.prototype.put = function (serviceName, path, data, config) {
	          if (config === void 0) { config = {}; }
	          config.method = 'PUT';
	          config.data = data;
	          return this.serviceRequest(serviceName, path, config);
	      };
	      Http.prototype.patch = function (serviceName, path, data, config) {
	          if (config === void 0) { config = {}; }
	          config.method = 'PATCH';
	          config.data = data;
	          return this.serviceRequest(serviceName, path, config);
	      };
	      Http.prototype.delete = function (serviceName, path, config) {
	          if (config === void 0) { config = {}; }
	          config.method = 'DELETE';
	          return this.serviceRequest(serviceName, path, config);
	      };
	      Http.prototype.head = function (serviceName, path, config) {
	          if (config === void 0) { config = {}; }
	          config.method = 'HEAD';
	          return this.serviceRequest(serviceName, path, config);
	      };
	      return Http;
	  }());
	  exports.default = Http;

	  });

	  unwrapExports(Http_1);

	  var Preferences_1 = createCommonjsModule(function (module, exports) {
	  Object.defineProperty(exports, "__esModule", { value: true });

	  var Http_1$1 = tslib_es6.__importDefault(Http_1);
	  var DEFAULT_CONFIG = {
	      http: new Http_1$1.default(),
	  };
	  var Preferences = /** @class */ (function () {
	      function Preferences(config) {
	          if (config === void 0) { config = DEFAULT_CONFIG; }
	          this.config = tslib_es6.__assign(tslib_es6.__assign({}, DEFAULT_CONFIG), config);
	      }
	      Preferences.prototype.get = function (path, cache) {
	          if (path === void 0) { path = null; }
	          if (cache === void 0) { cache = true; }
	          var reqPath = 'preferences';
	          if (path) {
	              reqPath += '/' + path;
	          }
	          return this.config.http.get('portal_service', reqPath, { version: 2, cache: cache }).then(function (resp) {
	              return resp.data;
	          });
	      };
	      Preferences.prototype.update = function (prefs) {
	          return this.config.http.put('portal_service', 'preferences', prefs, { version: 2 }).then(function (resp) {
	              return resp.data;
	          });
	      };
	      Preferences.prototype.patch = function (path, prefs) {
	          return this.config.http.patch('portal_service', "preferences/" + path, prefs, { version: 2 }).then(function (resp) {
	              return resp.data;
	          });
	      };
	      Preferences.prototype.delete = function (path) {
	          return this.config.http.delete('portal_service', "preferences/" + path, { version: 2 }).then(function (resp) {
	              return resp.data;
	          });
	      };
	      Preferences.prototype.deleteAll = function () {
	          return this.config.http.delete('portal_service', 'preferences', { version: 2 });
	      };
	      return Preferences;
	  }());
	  exports.default = Preferences;

	  });

	  unwrapExports(Preferences_1);

	  var Locale_1 = createCommonjsModule(function (module, exports) {
	  Object.defineProperty(exports, "__esModule", { value: true });
	  var Locale = /** @class */ (function () {
	      function Locale() {
	          this.LOCALE_COOKIE_NAME = 'pos.rn.locale';
	      }
	      Locale.prototype.getCookieValue = function (cookieName) {
	          var match = document.cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'));
	          if (match) {
	              return decodeURIComponent(match[2]);
	          }
	          return null;
	      };
	      Locale.prototype.getBestFit = function () {
	          var cookie = JSON.parse(this.getCookieValue(this.LOCALE_COOKIE_NAME));
	          if (cookie && cookie.locale) {
	              return cookie.locale.split('-')[0];
	          }
	          return window.navigator.language.split('-')[0];
	      };
	      return Locale;
	  }());
	  exports.default = Locale;

	  });

	  unwrapExports(Locale_1);

	  var dist = createCommonjsModule(function (module, exports) {
	  Object.defineProperty(exports, "__esModule", { value: true });

	  var Cache_1$1 = tslib_es6.__importDefault(Cache_1);
	  var Registry_1$1 = tslib_es6.__importDefault(Registry_1);
	  var Http_1$1 = tslib_es6.__importDefault(Http_1);
	  var Preferences_1$1 = tslib_es6.__importDefault(Preferences_1);
	  var Locale_1$1 = tslib_es6.__importDefault(Locale_1);
	  // TODO: move into Registry and have it listen for blue ready
	  function getRegistryHost() {
	      var host = '';
	      if (window.printos &&
	          window.printos.blue &&
	          window.printos.blue.ui &&
	          window.printos.blue.ui.registry) {
	          host = window.printos.blue.ui.registry.host;
	      }
	      return host;
	  }
	  exports.cache = new Cache_1$1.default();
	  exports.registry = new Registry_1$1.default({
	      cache: exports.cache,
	      host: getRegistryHost(),
	  });
	  exports.http = new Http_1$1.default({
	      cache: exports.cache,
	      registry: exports.registry
	  });
	  exports.preferences = new Preferences_1$1.default({ http: exports.http });
	  exports.locale = new Locale_1$1.default();

	  });

	  unwrapExports(dist);
	  var dist_1 = dist.cache;
	  var dist_2 = dist.registry;
	  var dist_3 = dist.http;
	  var dist_4 = dist.preferences;
	  var dist_5 = dist.locale;

	  var isMergeableObject = function isMergeableObject(value) {
	  	return isNonNullObject(value)
	  		&& !isSpecial(value)
	  };

	  function isNonNullObject(value) {
	  	return !!value && typeof value === 'object'
	  }

	  function isSpecial(value) {
	  	var stringValue = Object.prototype.toString.call(value);

	  	return stringValue === '[object RegExp]'
	  		|| stringValue === '[object Date]'
	  		|| isReactElement(value)
	  }

	  // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	  var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	  var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

	  function isReactElement(value) {
	  	return value.$$typeof === REACT_ELEMENT_TYPE
	  }

	  function emptyTarget(val) {
	  	return Array.isArray(val) ? [] : {}
	  }

	  function cloneUnlessOtherwiseSpecified(value, options) {
	  	return (options.clone !== false && options.isMergeableObject(value))
	  		? deepmerge(emptyTarget(value), value, options)
	  		: value
	  }

	  function defaultArrayMerge(target, source, options) {
	  	return target.concat(source).map(function(element) {
	  		return cloneUnlessOtherwiseSpecified(element, options)
	  	})
	  }

	  function mergeObject(target, source, options) {
	  	var destination = {};
	  	if (options.isMergeableObject(target)) {
	  		Object.keys(target).forEach(function(key) {
	  			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
	  		});
	  	}
	  	Object.keys(source).forEach(function(key) {
	  		if (!options.isMergeableObject(source[key]) || !target[key]) {
	  			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
	  		} else {
	  			destination[key] = deepmerge(target[key], source[key], options);
	  		}
	  	});
	  	return destination
	  }

	  function deepmerge(target, source, options) {
	  	options = options || {};
	  	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	  	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	  	var sourceIsArray = Array.isArray(source);
	  	var targetIsArray = Array.isArray(target);
	  	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	  	if (!sourceAndTargetTypesMatch) {
	  		return cloneUnlessOtherwiseSpecified(source, options)
	  	} else if (sourceIsArray) {
	  		return options.arrayMerge(target, source, options)
	  	} else {
	  		return mergeObject(target, source, options)
	  	}
	  }

	  deepmerge.all = function deepmergeAll(array, options) {
	  	if (!Array.isArray(array)) {
	  		throw new Error('first argument should be an array')
	  	}

	  	return array.reduce(function(prev, next) {
	  		return deepmerge(prev, next, options)
	  	}, {})
	  };

	  var deepmerge_1 = deepmerge;

	  // gutted from https://github.com/Polymer/observe-js/blob/master/src/observe.js
	  function noop$1 () {}
	  function detectEval () {
	    // Don't test for eval if we're running in a Chrome App environment.
	    // We check for APIs set that only exist in a Chrome App context.
	    if (typeof chrome !== 'undefined' && chrome.app && chrome.app.runtime) {
	      return false
	    }

	    // Firefox OS Apps do not allow eval. This feature detection is very hacky
	    // but even if some other platform adds support for this function this code
	    // will continue to work.
	    if (typeof navigator != 'undefined' && navigator.getDeviceStorage) {
	      return false
	    }

	    try {
	      var f = new Function('', 'return true;');
	      return f()
	    } catch (ex) {
	      return false
	    }
	  }

	  var hasEval = detectEval();

	  function isIndex (s) {
	    return +s === s >>> 0 && s !== ''
	  }

	  function isObject (obj) {
	    return obj === Object(obj)
	  }

	  var createObject = ('__proto__' in {}) ?
	    function (obj) {
	      return obj
	    } :
	    function (obj) {
	      var proto = obj.__proto__;
	      if (!proto)
	        return obj
	      var newObject = Object.create(proto);
	      Object.getOwnPropertyNames(obj).forEach(function (name) {
	        Object.defineProperty(newObject, name,
	          Object.getOwnPropertyDescriptor(obj, name));
	      });
	      return newObject
	    };

	  function parsePath (path) {
	    var keys = [];
	    var index = -1;
	    var c, newChar, key, type, transition, action, typeMap, mode = 'beforePath';

	    var actions = {
	      push: function () {
	        if (key === undefined)
	          return

	        keys.push(key);
	        key = undefined;
	      },

	      append: function () {
	        if (key === undefined)
	          key = newChar;
	        else
	          key += newChar;
	      }
	    };

	    function maybeUnescapeQuote () {
	      if (index >= path.length)
	        return

	      var nextChar = path[index + 1];
	      if ((mode == 'inSingleQuote' && nextChar == "'") ||
	        (mode == 'inDoubleQuote' && nextChar == '"')) {
	        index++;
	        newChar = nextChar;
	        actions.append();
	        return true
	      }
	    }

	    while (mode) {
	      index++;
	      c = path[index];

	      if (c == '\\' && maybeUnescapeQuote())
	        continue

	      type = getPathCharType(c);
	      typeMap = pathStateMachine[mode];
	      transition = typeMap[type] || typeMap['else'] || 'error';

	      if (transition == 'error')
	        return // parse error

	      mode = transition[0];
	      action = actions[transition[1]] || noop$1;
	      newChar = transition[2] === undefined ? c : transition[2];
	      action();

	      if (mode === 'afterPath') {
	        return keys
	      }
	    }

	    return // parse error
	  }

	  var identStart = '[\$_a-zA-Z]';
	  var identPart = '[\$_a-zA-Z0-9]';
	  var identRegExp = new RegExp('^' + identStart + '+' + identPart + '*' + '$');

	  function isIdent (s) {
	    return identRegExp.test(s)
	  }

	  var constructorIsPrivate = {};

	  function Path (parts, privateToken) {
	    if (privateToken !== constructorIsPrivate)
	      throw Error('Use Path.get to retrieve path objects')

	    for (var i = 0; i < parts.length; i++) {
	      this.push(String(parts[i]));
	    }

	    if (hasEval && this.length) {
	      this.getValueFrom = this.compiledGetValueFromFn();
	    }
	  }

	  var pathCache = {};

	  function getPath (pathString) {
	    if (pathString instanceof Path)
	      return pathString

	    if (pathString == null || pathString.length == 0)
	      pathString = '';

	    if (typeof pathString != 'string') {
	      if (isIndex(pathString.length)) {
	        // Constructed with array-like (pre-parsed) keys
	        return new Path(pathString, constructorIsPrivate)
	      }

	      pathString = String(pathString);
	    }

	    var path = pathCache[pathString];
	    if (path)
	      return path

	    var parts = parsePath(pathString);
	    if (!parts)
	      return invalidPath

	    var path = new Path(parts, constructorIsPrivate);
	    pathCache[pathString] = path;
	    return path
	  }

	  Path.get = getPath;

	  function formatAccessor (key) {
	    if (isIndex(key)) {
	      return '[' + key + ']'
	    } else {
	      return '["' + key.replace(/"/g, '\\"') + '"]'
	    }
	  }

	  Path.prototype = createObject({
	    __proto__: [],
	    valid: true,

	    toString: function () {
	      var pathString = '';
	      for (var i = 0; i < this.length; i++) {
	        var key = this[i];
	        if (isIdent(key)) {
	          pathString += i ? '.' + key : key;
	        } else {
	          pathString += formatAccessor(key);
	        }
	      }

	      return pathString
	    },

	    getValueFrom: function (obj, directObserver) {
	      for (var i = 0; i < this.length; i++) {
	        if (obj == null)
	          return
	        obj = obj[this[i]];
	      }
	      return obj
	    },

	    iterateObjects: function (obj, observe) {
	      for (var i = 0; i < this.length; i++) {
	        if (i)
	          obj = obj[this[i - 1]];
	        if (!isObject(obj))
	          return
	        observe(obj, this[i]);
	      }
	    },

	    compiledGetValueFromFn: function () {
	      var str = '';
	      var pathString = 'obj';
	      str += 'if (obj != null';
	      var i = 0;
	      var key;
	      for (; i < (this.length - 1); i++) {
	        key = this[i];
	        pathString += isIdent(key) ? '.' + key : formatAccessor(key);
	        str += ' &&\n     ' + pathString + ' != null';
	      }
	      str += ')\n';

	      var key = this[i];
	      pathString += isIdent(key) ? '.' + key : formatAccessor(key);

	      str += '  return ' + pathString + ';\nelse\n  return undefined;';
	      return new Function('obj', str)
	    },

	    setValueFrom: function (obj, value) {
	      if (!this.length)
	        return false

	      for (var i = 0; i < this.length - 1; i++) {
	        if (!isObject(obj))
	          return false
	        obj = obj[this[i]];
	      }

	      if (!isObject(obj))
	        return false

	      obj[this[i]] = value;
	      return true
	    }
	  });

	  function getPathCharType (char) {
	    if (char === undefined)
	      return 'eof'

	    var code = char.charCodeAt(0);

	    switch (code) {
	      case 0x5B: // [
	      case 0x5D: // ]
	      case 0x2E: // .
	      case 0x22: // "
	      case 0x27: // '
	      case 0x30: // 0
	        return char

	      case 0x5F: // _
	      case 0x24: // $
	        return 'ident'

	      case 0x20: // Space
	      case 0x09: // Tab
	      case 0x0A: // Newline
	      case 0x0D: // Return
	      case 0xA0: // No-break space
	      case 0xFEFF: // Byte Order Mark
	      case 0x2028: // Line Separator
	      case 0x2029: // Paragraph Separator
	        return 'ws'
	    }

	    // a-z, A-Z
	    if ((0x61 <= code && code <= 0x7A) || (0x41 <= code && code <= 0x5A))
	      return 'ident'

	    // 1-9
	    if (0x31 <= code && code <= 0x39)
	      return 'number'

	    return 'else'
	  }

	  var pathStateMachine = {
	    'beforePath': {
	      'ws': ['beforePath'],
	      'ident': ['inIdent', 'append'],
	      '[': ['beforeElement'],
	      'eof': ['afterPath']
	    },

	    'inPath': {
	      'ws': ['inPath'],
	      '.': ['beforeIdent'],
	      '[': ['beforeElement'],
	      'eof': ['afterPath']
	    },

	    'beforeIdent': {
	      'ws': ['beforeIdent'],
	      'ident': ['inIdent', 'append']
	    },

	    'inIdent': {
	      'ident': ['inIdent', 'append'],
	      '0': ['inIdent', 'append'],
	      'number': ['inIdent', 'append'],
	      'ws': ['inPath', 'push'],
	      '.': ['beforeIdent', 'push'],
	      '[': ['beforeElement', 'push'],
	      'eof': ['afterPath', 'push']
	    },

	    'beforeElement': {
	      'ws': ['beforeElement'],
	      '0': ['afterZero', 'append'],
	      'number': ['inIndex', 'append'],
	      "'": ['inSingleQuote', 'append', ''],
	      '"': ['inDoubleQuote', 'append', '']
	    },

	    'afterZero': {
	      'ws': ['afterElement', 'push'],
	      ']': ['inPath', 'push']
	    },

	    'inIndex': {
	      '0': ['inIndex', 'append'],
	      'number': ['inIndex', 'append'],
	      'ws': ['afterElement'],
	      ']': ['inPath', 'push']
	    },

	    'inSingleQuote': {
	      "'": ['afterElement'],
	      'eof': ['error'],
	      'else': ['inSingleQuote', 'append']
	    },

	    'inDoubleQuote': {
	      '"': ['afterElement'],
	      'eof': ['error'],
	      'else': ['inDoubleQuote', 'append']
	    },

	    'afterElement': {
	      'ws': ['afterElement'],
	      ']': ['inPath', 'push']
	    }
	  };

	  var invalidPath = new Path('', constructorIsPrivate);
	  invalidPath.valid = false;
	  invalidPath.getValueFrom = invalidPath.setValueFrom = function () {};

	  var path = Path;

	  /**
	   *
	   * @param {Object} o
	   * @param {String} path
	   * @returns {*}
	   */
	  var objectResolvePath = function (o, path$1) {
	    if (typeof path$1 !== 'string') {
	      throw new TypeError('path must be a string')
	    }
	    if (typeof o !== 'object') {
	      throw new TypeError('object must be passed')
	    }
	    var pathObj = path.get(path$1);
	    if (!pathObj.valid) {
	      throw new Error('path is not a valid object path')
	    }
	    return pathObj.getValueFrom(o)
	  };

	  var t=function(e){return e.replace(/(^|\s)\S/,function(e){return e.toUpperCase()})},r=function(e){return e.replace(/(^|\s)\S/g,function(e){return e.toUpperCase()})},o=function(e){return e.toLocaleUpperCase()},a=function(e){return e.toLocaleLowerCase()},u=function(e){return null!==e&&"object"==typeof e},i=/^(\d)+/,c=/^(\w)+/,l=function(){this._caches=Object.create(null);};function s(u,i){var c,s=i.dictionary,f=new l,p=Array.isArray(s)?deepmerge_1.all(s):s,v=function(e,t,r,o){void 0===r&&(r=c),void 0===o&&(o=void 0);var a=objectResolvePath(p[r],e);if(!a)return e;if(o)for(var u=0,i=o.length;u<i;u++)a=o[u](a);return t&&(a=f.interpolate(a,t).join("")),a.trim()},h=function(e,n,r){return t(v(e,n,r))},d=function(e,n,t){return r(v(e,n,t))},y=function(e,n,t){return o(v(e,n,t))},m=function(e,n,t){return a(v(e,n,t))},w=function(e,n,t,r){return v(e,t,r,[function(e){var t=e.split("|"),r=2===t.length,o=r?1:0;return "number"==typeof n&&(o=Math.min(Math.abs(n)-(r?1:0),t.length-1)),t[o]}])};return u.on("locale",function(e){if(Object.keys(p).includes(e)){c=e;var n=v;n.upper=y,n.lower=m,n.title=d,n.capital=h,n.plural=w,u.set({locale:e,_:n});}else console.error("[svelte-i18n] Couldn't find the \""+e+'" locale.');}),u.i18n={setLocale:function(e){u.fire("locale",e);},extendDictionary:function(){for(var n=[],t=arguments.length;t--;)n[t]=arguments[t];p=deepmerge_1.all([p].concat(n));}},u}l.prototype.interpolate=function(e,n){if(!n)return [e];var t=this._caches[e];return t||(t=function(e){var n=[],t=0,r="";for(;t<e.length;){var o=e[t++];if("{"!==o||t>0&&"\\"===o[t-1])r+=o;else{r.length&&n.push({type:"text",value:r}),r="";var a="";for(o=e[t++];"}"!==o;)a+=o,o=e[t++];var u=i.test(a)?"list":c.test(a)?"named":"unknown";n.push({value:a,type:u});}}r&&n.push({type:"text",value:r});return n}(e),this._caches[e]=t),function(e,n){var t=[],r=0,o=Array.isArray(n)?"list":u(n)?"named":"unknown";if("unknown"===o)return t;for(;r<e.length;){var a=e[r++];switch(a.type){case"text":t.push(a.value);break;case"list":t.push(n[parseInt(a.value,10)]);break;case"named":"named"===o?t.push(n[a.value]):"production"!=="production"&&console.warn("[svelte-i18n] Type of token '"+a.type+"' and format of value '"+o+"' don't match!");break;}}return t}(t,n)};

	  function Store(state, options) {
	    this._handlers = {};
	    this._dependents = [];
	    this._computed = blankObject();
	    this._sortedComputedProperties = [];
	    this._state = assign({}, state);
	    this._differs = options && options.immutable ? _differsImmutable : _differs;
	  }

	  assign(Store.prototype, {
	    _add: function _add(component, props) {
	      this._dependents.push({
	        component: component,
	        props: props
	      });
	    },
	    _init: function _init(props) {
	      var state = {};

	      for (var i = 0; i < props.length; i += 1) {
	        var prop = props[i];
	        state['$' + prop] = this._state[prop];
	      }

	      return state;
	    },
	    _remove: function _remove(component) {
	      var i = this._dependents.length;

	      while (i--) {
	        if (this._dependents[i].component === component) {
	          this._dependents.splice(i, 1);

	          return;
	        }
	      }
	    },
	    _set: function _set(newState, changed) {
	      var _this = this;

	      var previous = this._state;
	      this._state = assign(assign({}, previous), newState);

	      for (var i = 0; i < this._sortedComputedProperties.length; i += 1) {
	        this._sortedComputedProperties[i].update(this._state, changed);
	      }

	      this.fire('state', {
	        changed: changed,
	        previous: previous,
	        current: this._state
	      });

	      this._dependents.filter(function (dependent) {
	        var componentState = {};
	        var dirty = false;

	        for (var j = 0; j < dependent.props.length; j += 1) {
	          var prop = dependent.props[j];

	          if (prop in changed) {
	            componentState['$' + prop] = _this._state[prop];
	            dirty = true;
	          }
	        }

	        if (dirty) {
	          dependent.component._stage(componentState);

	          return true;
	        }
	      }).forEach(function (dependent) {
	        dependent.component.set({});
	      });

	      this.fire('update', {
	        changed: changed,
	        previous: previous,
	        current: this._state
	      });
	    },
	    _sortComputedProperties: function _sortComputedProperties() {
	      var computed = this._computed;
	      var sorted = this._sortedComputedProperties = [];
	      var visited = blankObject();
	      var currentKey;

	      function visit(key) {
	        var c = computed[key];

	        if (c) {
	          c.deps.forEach(function (dep) {
	            if (dep === currentKey) {
	              throw new Error("Cyclical dependency detected between ".concat(dep, " <-> ").concat(key));
	            }

	            visit(dep);
	          });

	          if (!visited[key]) {
	            visited[key] = true;
	            sorted.push(c);
	          }
	        }
	      }

	      for (var key in this._computed) {
	        visit(currentKey = key);
	      }
	    },
	    compute: function compute(key, deps, fn) {
	      var _this2 = this;

	      var value;
	      var c = {
	        deps: deps,
	        update: function update(state, changed, dirty) {
	          var values = deps.map(function (dep) {
	            if (dep in changed) dirty = true;
	            return state[dep];
	          });

	          if (dirty) {
	            var newValue = fn.apply(null, values);

	            if (_this2._differs(newValue, value)) {
	              value = newValue;
	              changed[key] = true;
	              state[key] = value;
	            }
	          }
	        }
	      };
	      this._computed[key] = c;

	      this._sortComputedProperties();

	      var state = assign({}, this._state);
	      var changed = {};
	      c.update(state, changed, true);

	      this._set(state, changed);
	    },
	    fire: fire,
	    get: get,
	    on: on,
	    set: function set(newState) {
	      var oldState = this._state;
	      var changed = this._changed = {};
	      var dirty = false;

	      for (var key in newState) {
	        if (this._computed[key]) throw new Error("'".concat(key, "' is a read-only computed property"));
	        if (this._differs(newState[key], oldState[key])) changed[key] = dirty = true;
	      }

	      if (!dirty) return;

	      this._set(newState, changed);
	    }
	  });

	  // Using double quotes in this file to prevent issues with apostrophies (')
	  var de = {
	    Help_Title: "PrintOS-Hilfe - {0}",
	    Help_FeedbackQuestion: "Waren diese Angaben hilfreich?",
	    Help_FeedbackDetails: "Feedback",
	    Help_FeedbackDetailsDisclaimer: "Bitte geben Sie aus Datenschutz- und Sicherheitsgründen keine persönlichen Informationen wie Ihre Telefonnummer oder E-Mail-Adresse im Kommentarbereich an.",
	    Help_FeedbackDetailsHeader: "Danke für Ihre Hilfe! Wir schätzen Ihr Feedback.",
	    Help_FeedbackDetailsQuestion: "Wie können wir dieses Thema verbessern?",
	    Help_FeedbackThanks: "Vielen Dank für Ihre Rückmeldung!",
	    Help_RetrieveError_NotFound: "Ein Fehler ist aufgetreten. Wir können dieses Dokument nicht finden.",
	    Help_RetrieveError_Unauthorized: "Ein Fehler ist aufgetreten. Sie sind nicht berechtigt, dieses Dokument anzuzeigen.",
	    Help_RetrieveError_Unknown: "Ein Fehler ist aufgetreten. Wir können dieses Dokument nicht abrufen. Versuchen Sie es später erneut."
	  };

	  // Using double quotes in this file to prevent issues with apostrophies (')
	  var en = {
	    Help_Title: "PrintOS Help - {0}",
	    Help_FeedbackQuestion: "Was this information helpful?",
	    Help_FeedbackDetails: "Feedback",
	    Help_FeedbackDetailsDisclaimer: "For your privacy and security, please do not include personal information such as your phone number or email address in the comments section.",
	    Help_FeedbackDetailsHeader: "Thank you for helping us! We value your feedback.",
	    Help_FeedbackDetailsQuestion: "How can we improve this topic?",
	    Help_FeedbackThanks: "Thank you for your feedback!",
	    Help_RetrieveError_NotFound: "Sorry, something went wrong. We are unable to find this document.",
	    Help_RetrieveError_Unauthorized: "Sorry, something went wrong. You are not authorized to see this document.",
	    Help_RetrieveError_Unknown: "Sorry, something went wrong. We are unable to retrieve this document. Please try again later."
	  };

	  // Using double quotes in this file to prevent issues with apostrophies (')
	  var es = {
	    Help_Title: "Ayuda de PrintOS - {0}",
	    Help_FeedbackQuestion: "¿Le ha sido útil esta información?",
	    Help_FeedbackDetails: "Comentarios",
	    Help_FeedbackDetailsDisclaimer: "Para garantizar su privacidad y seguridad, no incluya información personal (como su número de teléfono o dirección de correo electrónico) en la sección de comentarios.",
	    Help_FeedbackDetailsHeader: "¡Gracias por su ayuda! Apreciamos sus comentarios.",
	    Help_FeedbackDetailsQuestion: "¿Cómo podemos mejorar este tema?",
	    Help_FeedbackThanks: "¡Gracias por su retorno!",
	    Help_RetrieveError_NotFound: "Se produjo un problema. No encontramos el documento.",
	    Help_RetrieveError_Unauthorized: "Se produjo un problema. No tiene autorización para ver el documento.",
	    Help_RetrieveError_Unknown: "Se produjo un problema. No podemos recuperar el documento. Vuelva a intentarlo más tarde."
	  };

	  // Using double quotes in this file to prevent issues with apostrophies (')
	  var fr = {
	    Help_Title: "Aide de PrintOS - {0}",
	    Help_FeedbackQuestion: "Ces informations vous ont-elles été utiles ?",
	    Help_FeedbackDetails: "Avis",
	    Help_FeedbackDetailsDisclaimer: "Pour votre confidentialité et votre sécurité, veuillez ne pas inclure de renseignements personnels, tels que votre numéro de téléphone ou votre adresse e-mail dans la section des commentaires.",
	    Help_FeedbackDetailsHeader: "Merci de nous aider ! Nous apprécions vos avis.",
	    Help_FeedbackDetailsQuestion: "Comment pouvons-nous améliorer cette rubrique ?",
	    Help_FeedbackThanks: "Merci pour votre avis !",
	    Help_RetrieveError_NotFound: "Désolé, un problème est survenu. Impossible trouver ce document.",
	    Help_RetrieveError_Unauthorized: "Désolé, un problème est survenu. Vous n’êtes pas autorisé à voir ce document.",
	    Help_RetrieveError_Unknown: "Désolé, un problème est survenu. Nous ne sommes pas en mesure de récupérer ce document. Veuillez réessayer plus tard."
	  };

	  // Using double quotes in this file to prevent issues with apostrophies (')
	  var it = {
	    Help_Title: "Guida a PrintOS - {0}",
	    Help_FeedbackQuestion: "Le informazioni sono risultate utili?",
	    Help_FeedbackDetails: "Feedback",
	    Help_FeedbackDetailsDisclaimer: "Per garantire la privacy e la sicurezza, non includere i dati personali come il numero di telefono o l'indirizzo email nella sezione Commenti.",
	    Help_FeedbackDetailsHeader: "Grazie per il tuo contributo. Apprezziamo i tuoi commenti.",
	    Help_FeedbackDetailsQuestion: "Come possiamo migliorare questo argomento?",
	    Help_FeedbackThanks: "Grazie per il feedback!",
	    Help_RetrieveError_NotFound: "Si  è verificato un errore. Impossibile trovare il documento.",
	    Help_RetrieveError_Unauthorized: "Si  è verificato un errore. Autorizzazioni mancanti per visionare il documento.",
	    Help_RetrieveError_Unknown: "Si  è verificato un errore. Impossibile trovare il documento. Riprova più tardi."
	  };

	  // Using double quotes in this file to prevent issues with apostrophies (')
	  var ja = {
	    Help_Title: "PrintOSヘルプ - {0}",
	    Help_FeedbackQuestion: "この情報は役に立ちましたか?",
	    Help_FeedbackDetails: "フィードバック",
	    Help_FeedbackDetailsDisclaimer: "プライバシーとセキュリティを保護するため、電話番号や電子メールアドレスなどの個人情報をコメントセクションに記入しないでください。",
	    Help_FeedbackDetailsHeader: "ご協力ありがとうございました。いただいたフィードバックを参考にさせていただきます。",
	    Help_FeedbackDetailsQuestion: "このトピックについて改善点をお聞かせください。",
	    Help_FeedbackThanks: "フィードバックをありがとうございました。",
	    Help_RetrieveError_NotFound: "問題が発生しました。このドキュメントが見つかりません。",
	    Help_RetrieveError_Unauthorized: "問題が発生しました。このドキュメントを閲覧する権限がありません。",
	    Help_RetrieveError_Unknown: "問題が発生しました。このドキュメントを取得できません。後でやり直してください。"
	  };

	  // Using double quotes in this file to prevent issues with apostrophies (')
	  var ko = {
	    Help_Title: "PrintOS 도움말 - {0}",
	    Help_FeedbackQuestion: "이 정보가 유용했습니까?",
	    Help_FeedbackDetails: "피드백",
	    Help_FeedbackDetailsDisclaimer: "개인 정보 보호 및 보안을 위해 설명 섹션에 이메일 주소 또는 전화 번호와 같은 개인 정보를 입력하지 마십시오.",
	    Help_FeedbackDetailsHeader: "도움을 주셔서 감사합니다! 귀하의 피드백은 소중합니다.",
	    Help_FeedbackDetailsQuestion: "이 항목을 어떻게 개선할 수 있습니까?",
	    Help_FeedbackThanks: "피드백에 감사드립니다!",
	    Help_RetrieveError_NotFound: "죄송합니다. 문제가 발생했습니다. 이 문서를 찾을 수 없습니다.",
	    Help_RetrieveError_Unauthorized: "죄송합니다. 문제가 발생했습니다. 이 문서를 볼 수 있는 권한이 없습니다.",
	    Help_RetrieveError_Unknown: "죄송합니다. 문제가 발생했습니다. 이 문서를 검색할 수 없습니다. 나중에 다시 시도하십시오."
	  };

	  // Using double quotes in this file to prevent issues with apostrophies (')
	  var pt = {
	    Help_Title: "Ajuda do PrintOS - {0}",
	    Help_FeedbackQuestion: "Essas informações foram úteis?",
	    Help_FeedbackDetails: "Feedback",
	    Help_FeedbackDetailsDisclaimer: "Para sua privacidade e segurança, não inclua informações pessoais tais como número de telefone nem endereço de e-mail na seção de comentários.",
	    Help_FeedbackDetailsHeader: "Obrigado pela ajuda! Seus comentários são importantes para nós.",
	    Help_FeedbackDetailsQuestion: "Como podemos melhorar este tópico?",
	    Help_FeedbackThanks: "Agradecemos o seu feedback",
	    Help_RetrieveError_NotFound: "Alguma coisa deu errado. Não foi possível encontrar este documento.",
	    Help_RetrieveError_Unauthorized: "Alguma coisa deu errado. Você não está autorizado a ver este documento.",
	    Help_RetrieveError_Unknown: "Alguma coisa deu errado. Não foi possível recuperar este documento. Tente de novo mais tarde."
	  };

	  // Using double quotes in this file to prevent issues with apostrophies (')
	  var ru = {
	    Help_Title: "Справка PrintOS - {0}",
	    Help_FeedbackQuestion: "Оказалась ли эта информация полезной?",
	    Help_FeedbackDetails: "Отзыв",
	    Help_FeedbackDetailsDisclaimer: "Для обеспечения конфиденциальности и безопасности своих данных не указывайте в разделе комментариев личные сведения, такие как номер телефона или адрес эл. почты.",
	    Help_FeedbackDetailsHeader: "Спасибо за помощь! Мы высоко ценим ваше мнение.",
	    Help_FeedbackDetailsQuestion: "Что можно улучшить?",
	    Help_FeedbackThanks: "Благодарим за отзыв!",
	    Help_RetrieveError_NotFound: "К сожалению, что-то пошло не так. Найти этот документ не удалось.",
	    Help_RetrieveError_Unauthorized: "К сожалению, что-то пошло не так. У вас нет прав на просмотр этого документа.",
	    Help_RetrieveError_Unknown: "К сожалению, что-то пошло не так. Получить этот документ не удалось. Повторите попытку позже."
	  };

	  // Using double quotes in this file to prevent issues with apostrophies (')
	  var zh = {
	    Help_Title: "PrintOS 帮助 - {0}",
	    Help_FeedbackQuestion: "这些信息是否有帮助?",
	    Help_FeedbackDetails: "反馈",
	    Help_FeedbackDetailsDisclaimer: "出于隐私和安全考虑，请勿在注释部分包含电话号码或电子邮件地址等个人信息。",
	    Help_FeedbackDetailsHeader: "感谢您帮助我们改进! 您的反馈对我们十分重要。",
	    Help_FeedbackDetailsQuestion: "在此主题上我们如何改善?",
	    Help_FeedbackThanks: "感谢您的反馈!",
	    Help_RetrieveError_NotFound: "抱歉，出现问题。我们无法找到此文档。",
	    Help_RetrieveError_Unauthorized: "抱歉，出现问题。您无权查看此文档。",
	    Help_RetrieveError_Unknown: "抱歉，出现问题。我们无法检索此文档。请稍后重试。"
	  };

	  var store = new Store();
	  var dictionary = {
	    de: de,
	    en: en,
	    es: es,
	    fr: fr,
	    it: it,
	    ja: ja,
	    ko: ko,
	    pt: pt,
	    ru: ru,
	    zh: zh
	  };
	  store = s(store, {
	    dictionary: dictionary
	  }); // Default to the browser locale, if present

	  var browserLang = dist_5.getBestFit();

	  if (dictionary[browserLang]) {
	    store.i18n.setLocale(browserLang);
	  } else {
	    store.i18n.setLocale('en');
	  }

	  var store$1 = store;

	  function cubicOut(t) {
	    var f = t - 1.0;
	    return f * f * f + 1.0
	  }

	  function slide(
	  	node,
	  	ref
	  ) {
	  	var delay = ref.delay; if ( delay === void 0 ) delay = 0;
	  	var duration = ref.duration; if ( duration === void 0 ) duration = 400;
	  	var easing = ref.easing; if ( easing === void 0 ) easing = cubicOut;

	  	var style = getComputedStyle(node);
	  	var opacity = +style.opacity;
	  	var height = parseFloat(style.height);
	  	var paddingTop = parseFloat(style.paddingTop);
	  	var paddingBottom = parseFloat(style.paddingBottom);
	  	var marginTop = parseFloat(style.marginTop);
	  	var marginBottom = parseFloat(style.marginBottom);
	  	var borderTopWidth = parseFloat(style.borderTopWidth);
	  	var borderBottomWidth = parseFloat(style.borderBottomWidth);

	  	return {
	  		delay: delay,
	  		duration: duration,
	  		easing: easing,
	  		css: function (t) { return "overflow: hidden;" +
	  			"opacity: " + (Math.min(t * 20, 1) * opacity) + ";" +
	  			"height: " + (t * height) + "px;" +
	  			"padding-top: " + (t * paddingTop) + "px;" +
	  			"padding-bottom: " + (t * paddingBottom) + "px;" +
	  			"margin-top: " + (t * marginTop) + "px;" +
	  			"margin-bottom: " + (t * marginBottom) + "px;" +
	  			"border-top-width: " + (t * borderTopWidth) + "px;" +
	  			"border-bottom-width: " + (t * borderBottomWidth) + "px;"; }
	  	};
	  }

	  var $t;

	  function showTitle(_ref) {
	    var pageTitle = _ref.pageTitle;
	    return $t('Help_Title', [pageTitle]);
	  }

	  function data() {
	    $t = store$1.get()._;
	    return {
	      pageTitle: '',
	      type: '',
	      url: '',
	      showSurvey: true,
	      notFoundMessage: $t('Help_RetrieveError_NotFound'),
	      helpFeedbackQuestion: $t('Help_FeedbackQuestion')
	    };
	  }
	  var methods = {
	    thumbsUpClicked: function thumbsUpClicked(event) {
	      event.stopPropagation();
	      this.set({
	        showSurvey: false
	      });
	      this.fire('thumbsUpClicked', event);
	    },
	    thumbsDownClicked: function thumbsDownClicked(event) {
	      event.stopPropagation();
	      this.set({
	        showSurvey: false
	      });
	      this.fire('thumbsDownClicked', event);
	    }
	  };

	  function oncreate() {
	    loadContent.call(this, 'hp', 'hpIcon');
	    loadContent.call(this, 'general/fa/thumbs-up', 'thumbUpIcon');
	    loadContent.call(this, 'general/fa/thumbs-down', 'thumbDownIcon');
	  }

	  function store_1() {
	    return store$1;
	  }
	  var slideDown = slide;

	  function loadContent(name, attr) {
	    var _this = this;

	    var url = "https://cdn.printos.com/images/".concat(name, ".svg");
	    var config = {
	      url: url,
	      cache: true,
	      credentials: 'omit',
	      responseType: 'text'
	    };
	    return dist_3.request(config).then(function (resp) {
	      _this.set(_defineProperty({}, attr, resp.data));
	    });
	  }

	  function add_css() {
	    var style = createElement("style");
	    style.id = 'svelte-1i1zwu1-style';
	    style.textContent = ".help-wrapper.svelte-1i1zwu1{display:flex;flex-direction:column;height:100vh;margin:0;color:#5A5A5A;font-family:Roboto, \"Helvetica Neue\", sans-serif;font-size:16px;min-height:100%}.help-wrapper.svelte-1i1zwu1,.help-wrapper.svelte-1i1zwu1 *,.help-wrapper.svelte-1i1zwu1 :after,.help-wrapper.svelte-1i1zwu1 :before{box-sizing:border-box}.help-wrapper.svelte-1i1zwu1::-webkit-scrollbar,.help-wrapper.svelte-1i1zwu1 ::-webkit-scrollbar{width:6px;height:6px}.help-wrapper.svelte-1i1zwu1::-webkit-scrollbar-track,.help-wrapper.svelte-1i1zwu1 ::-webkit-scrollbar-track{background-color:transparent}.help-wrapper.svelte-1i1zwu1::-webkit-scrollbar-thumb,.help-wrapper.svelte-1i1zwu1 ::-webkit-scrollbar-thumb{background-color:#CCCCCC;border-radius:10px}.help-wrapper.svelte-1i1zwu1 .header.svelte-1i1zwu1{display:flex;align-items:center;height:48px;padding:0 16px;color:#FFFFFF;background-color:#0096d6}.help-wrapper.svelte-1i1zwu1 .header.svelte-1i1zwu1 .hp-icon{height:32px;width:32px;color:#FFFFFF;margin-right:16px}.help-wrapper.svelte-1i1zwu1 .header.svelte-1i1zwu1 .hp-icon svg path{fill:#FFFFFF}.help-wrapper.svelte-1i1zwu1 .content.svelte-1i1zwu1{display:flex;flex:1}.help-wrapper.svelte-1i1zwu1 .content .material.svelte-1i1zwu1{flex:1;width:100%;border:none}.help-wrapper.svelte-1i1zwu1 .content .video.svelte-1i1zwu1{flex:1;max-height:100%}.help-wrapper.svelte-1i1zwu1 .content .video .videoplayer.svelte-1i1zwu1{height:100%;width:100%}.help-wrapper.svelte-1i1zwu1 .footer.svelte-1i1zwu1{display:flex;flex-direction:row;align-items:center;justify-content:center;border-top:1px solid #CCCCCC;padding:0 16px;height:64px}.help-wrapper.svelte-1i1zwu1 .footer .help-feedback.svelte-1i1zwu1{font-size:24px;font-weight:400;color:#5A5A5A}.help-wrapper.svelte-1i1zwu1 .footer.svelte-1i1zwu1 .feedback-image{margin:auto;background-repeat:no-repeat;display:inline-block;vertical-align:middle;fill:currentColor;height:48px;width:48px;margin:0 16px;cursor:pointer}.help-wrapper.svelte-1i1zwu1 .footer.svelte-1i1zwu1 .feedback-image.up{color:#509137}.help-wrapper.svelte-1i1zwu1 .footer.svelte-1i1zwu1 .feedback-image.down{color:#F04B37}.help-wrapper.svelte-1i1zwu1 .survey-container.svelte-1i1zwu1{overflow:hidden;padding-left:5px;max-height:64px;transition:max-height 0.5s linear}.help-wrapper.svelte-1i1zwu1 .pros-icon.svelte-1i1zwu1{width:24px;height:24px;line-height:24px;color:#4d4d4d}";
	    append(document.head, style);
	  }

	  function create_main_fragment(component, ctx) {
	    var div4, div2, div0, text0, div1, text1, text2, div3, text3;
	    var if_block0 = ctx.hpIcon && create_if_block_5(component, ctx);

	    function select_block_type(ctx) {
	      if (ctx.type == 'pdf' || ctx.type == 'url' || ctx.type == 'freshdesk') return create_if_block_3;
	      if (ctx.type == 'video') return create_if_block_4;
	      return create_else_block;
	    }

	    var current_block_type = select_block_type(ctx);
	    var if_block1 = current_block_type(component, ctx);
	    var if_block2 = (ctx.type == 'pdf' || ctx.type == 'url' || ctx.type == 'freshdesk' || ctx.type == 'video') && ctx.showSurvey && create_if_block(component, ctx);
	    return {
	      c: function c() {
	        div4 = createElement("div");
	        div2 = createElement("div");
	        div0 = createElement("div");
	        if (if_block0) if_block0.c();
	        text0 = createText("\n    ");
	        div1 = createElement("div");
	        text1 = createText(ctx.showTitle);
	        text2 = createText("\n  ");
	        div3 = createElement("div");
	        if_block1.c();
	        text3 = createText("\n  ");
	        if (if_block2) if_block2.c();
	        div0.id = "hpIcon";
	        div0.className = "pros-icon hp-icon svelte-1i1zwu1";
	        div1.className = "help-title svelte-1i1zwu1";
	        div2.className = "header svelte-1i1zwu1";
	        div3.className = "content svelte-1i1zwu1";
	        div4.className = "help-wrapper svelte-1i1zwu1";
	      },
	      m: function m(target, anchor) {
	        insert(target, div4, anchor);
	        append(div4, div2);
	        append(div2, div0);
	        if (if_block0) if_block0.m(div0, null);
	        append(div2, text0);
	        append(div2, div1);
	        append(div1, text1);
	        append(div4, text2);
	        append(div4, div3);
	        if_block1.m(div3, null);
	        append(div4, text3);
	        if (if_block2) if_block2.i(div4, null);
	      },
	      p: function p(changed, ctx) {
	        if (ctx.hpIcon) {
	          if (if_block0) {
	            if_block0.p(changed, ctx);
	          } else {
	            if_block0 = create_if_block_5(component, ctx);
	            if_block0.c();
	            if_block0.m(div0, null);
	          }
	        } else if (if_block0) {
	          if_block0.d(1);
	          if_block0 = null;
	        }

	        if (changed.showTitle) {
	          setData(text1, ctx.showTitle);
	        }

	        if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block1) {
	          if_block1.p(changed, ctx);
	        } else {
	          if_block1.d(1);
	          if_block1 = current_block_type(component, ctx);
	          if_block1.c();
	          if_block1.m(div3, null);
	        }

	        if ((ctx.type == 'pdf' || ctx.type == 'url' || ctx.type == 'freshdesk' || ctx.type == 'video') && ctx.showSurvey) {
	          if (if_block2) {
	            if_block2.p(changed, ctx);
	          } else {
	            if_block2 = create_if_block(component, ctx);
	            if (if_block2) if_block2.c();
	          }

	          if_block2.i(div4, null);
	        } else if (if_block2) {
	          groupOutros();
	          if_block2.o(function () {
	            if_block2.d(1);
	            if_block2 = null;
	          });
	        }
	      },
	      d: function d(detach) {
	        if (detach) {
	          detachNode(div4);
	        }

	        if (if_block0) if_block0.d();
	        if_block1.d();
	        if (if_block2) if_block2.d();
	      }
	    };
	  } // (4:6) {#if hpIcon}


	  function create_if_block_5(component, ctx) {
	    var raw_before, raw_after;
	    return {
	      c: function c() {
	        raw_before = createElement('noscript');
	        raw_after = createElement('noscript');
	      },
	      m: function m(target, anchor) {
	        insert(target, raw_before, anchor);
	        raw_before.insertAdjacentHTML("afterend", ctx.hpIcon);
	        insert(target, raw_after, anchor);
	      },
	      p: function p(changed, ctx) {
	        if (changed.hpIcon) {
	          detachBetween(raw_before, raw_after);
	          raw_before.insertAdjacentHTML("afterend", ctx.hpIcon);
	        }
	      },
	      d: function d(detach) {
	        if (detach) {
	          detachBetween(raw_before, raw_after);
	          detachNode(raw_before);
	          detachNode(raw_after);
	        }
	      }
	    };
	  } // (21:4) {:else}


	  function create_else_block(component, ctx) {
	    var div, text;
	    return {
	      c: function c() {
	        div = createElement("div");
	        text = createText(ctx.notFoundMessage);
	        div.className = "svelte-1i1zwu1";
	      },
	      m: function m(target, anchor) {
	        insert(target, div, anchor);
	        append(div, text);
	      },
	      p: function p(changed, ctx) {
	        if (changed.notFoundMessage) {
	          setData(text, ctx.notFoundMessage);
	        }
	      },
	      d: function d(detach) {
	        if (detach) {
	          detachNode(div);
	        }
	      }
	    };
	  } // (15:29) 


	  function create_if_block_4(component, ctx) {
	    var div, video, source;
	    return {
	      c: function c() {
	        div = createElement("div");
	        video = createElement("video");
	        source = createElement("source");
	        source.src = ctx.url;
	        source.type = "video/mp4;codecs=\"avc1.42E01E, mp4a.40.2\"";
	        source.className = "svelte-1i1zwu1";
	        video.className = "videoplayer svelte-1i1zwu1";
	        video.controls = true;
	        video.preload = "auto";
	        div.className = "video svelte-1i1zwu1";
	      },
	      m: function m(target, anchor) {
	        insert(target, div, anchor);
	        append(div, video);
	        append(video, source);
	      },
	      p: function p(changed, ctx) {
	        if (changed.url) {
	          source.src = ctx.url;
	        }
	      },
	      d: function d(detach) {
	        if (detach) {
	          detachNode(div);
	        }
	      }
	    };
	  } // (13:4) {#if type == 'pdf' || type == 'url' || type == 'freshdesk'}


	  function create_if_block_3(component, ctx) {
	    var iframe;
	    return {
	      c: function c() {
	        iframe = createElement("iframe");
	        iframe.className = "material svelte-1i1zwu1";
	        iframe.src = ctx.url;
	        iframe.title = ctx.showTitle;
	      },
	      m: function m(target, anchor) {
	        insert(target, iframe, anchor);
	      },
	      p: function p(changed, ctx) {
	        if (changed.url) {
	          iframe.src = ctx.url;
	        }

	        if (changed.showTitle) {
	          iframe.title = ctx.showTitle;
	        }
	      },
	      d: function d(detach) {
	        if (detach) {
	          detachNode(iframe);
	        }
	      }
	    };
	  } // (27:2) {#if (type == 'pdf' || type == 'url' || type == 'freshdesk' || type ==   'video') && showSurvey}


	  function create_if_block(component, ctx) {
	    var div3, div2, label, text0, text1, div0, text2, div1, div3_transition, current;
	    var if_block0 = ctx.thumbUpIcon && create_if_block_2(component, ctx);

	    function click_handler(event) {
	      component.thumbsUpClicked(event);
	    }

	    var if_block1 = ctx.thumbDownIcon && create_if_block_1(component, ctx);

	    function click_handler_1(event) {
	      component.thumbsDownClicked(event);
	    }

	    return {
	      c: function c() {
	        div3 = createElement("div");
	        div2 = createElement("div");
	        label = createElement("label");
	        text0 = createText(ctx.helpFeedbackQuestion);
	        text1 = createText("\n      ");
	        div0 = createElement("div");
	        if (if_block0) if_block0.c();
	        text2 = createText("\n      ");
	        div1 = createElement("div");
	        if (if_block1) if_block1.c();
	        label.className = "help-feedback svelte-1i1zwu1";
	        addListener(div0, "click", click_handler);
	        div0.id = "thumbUpIcon";
	        div0.className = "pros-icon feedback-image up svelte-1i1zwu1";
	        addListener(div1, "click", click_handler_1);
	        div1.id = "thumbDownIcon";
	        div1.className = "pros-icon feedback-image down svelte-1i1zwu1";
	        div2.className = "footer svelte-1i1zwu1";
	        div3.className = "survey-container svelte-1i1zwu1";
	      },
	      m: function m(target, anchor) {
	        insert(target, div3, anchor);
	        append(div3, div2);
	        append(div2, label);
	        append(label, text0);
	        append(div2, text1);
	        append(div2, div0);
	        if (if_block0) if_block0.m(div0, null);
	        append(div2, text2);
	        append(div2, div1);
	        if (if_block1) if_block1.m(div1, null);
	        current = true;
	      },
	      p: function p(changed, ctx) {
	        if (!current || changed.helpFeedbackQuestion) {
	          setData(text0, ctx.helpFeedbackQuestion);
	        }

	        if (ctx.thumbUpIcon) {
	          if (if_block0) {
	            if_block0.p(changed, ctx);
	          } else {
	            if_block0 = create_if_block_2(component, ctx);
	            if_block0.c();
	            if_block0.m(div0, null);
	          }
	        } else if (if_block0) {
	          if_block0.d(1);
	          if_block0 = null;
	        }

	        if (ctx.thumbDownIcon) {
	          if (if_block1) {
	            if_block1.p(changed, ctx);
	          } else {
	            if_block1 = create_if_block_1(component, ctx);
	            if_block1.c();
	            if_block1.m(div1, null);
	          }
	        } else if (if_block1) {
	          if_block1.d(1);
	          if_block1 = null;
	        }
	      },
	      i: function i(target, anchor) {
	        if (current) return;

	        if (component.root._intro) {
	          if (div3_transition) div3_transition.invalidate();

	          component.root._aftercreate.push(function () {
	            if (!div3_transition) div3_transition = wrapTransition(component, div3, slideDown, {}, true);
	            div3_transition.run(1);
	          });
	        }

	        this.m(target, anchor);
	      },
	      o: function o(outrocallback) {
	        if (!current) return;
	        if (!div3_transition) div3_transition = wrapTransition(component, div3, slideDown, {}, false);
	        div3_transition.run(0, function () {
	          outrocallback();
	          div3_transition = null;
	        });
	        current = false;
	      },
	      d: function d(detach) {
	        if (detach) {
	          detachNode(div3);
	        }

	        if (if_block0) if_block0.d();
	        removeListener(div0, "click", click_handler);
	        if (if_block1) if_block1.d();
	        removeListener(div1, "click", click_handler_1);

	        if (detach) {
	          if (div3_transition) div3_transition.abort();
	        }
	      }
	    };
	  } // (35:8) {#if thumbUpIcon}


	  function create_if_block_2(component, ctx) {
	    var raw_before, raw_after;
	    return {
	      c: function c() {
	        raw_before = createElement('noscript');
	        raw_after = createElement('noscript');
	      },
	      m: function m(target, anchor) {
	        insert(target, raw_before, anchor);
	        raw_before.insertAdjacentHTML("afterend", ctx.thumbUpIcon);
	        insert(target, raw_after, anchor);
	      },
	      p: function p(changed, ctx) {
	        if (changed.thumbUpIcon) {
	          detachBetween(raw_before, raw_after);
	          raw_before.insertAdjacentHTML("afterend", ctx.thumbUpIcon);
	        }
	      },
	      d: function d(detach) {
	        if (detach) {
	          detachBetween(raw_before, raw_after);
	          detachNode(raw_before);
	          detachNode(raw_after);
	        }
	      }
	    };
	  } // (40:8) {#if thumbDownIcon}


	  function create_if_block_1(component, ctx) {
	    var raw_before, raw_after;
	    return {
	      c: function c() {
	        raw_before = createElement('noscript');
	        raw_after = createElement('noscript');
	      },
	      m: function m(target, anchor) {
	        insert(target, raw_before, anchor);
	        raw_before.insertAdjacentHTML("afterend", ctx.thumbDownIcon);
	        insert(target, raw_after, anchor);
	      },
	      p: function p(changed, ctx) {
	        if (changed.thumbDownIcon) {
	          detachBetween(raw_before, raw_after);
	          raw_before.insertAdjacentHTML("afterend", ctx.thumbDownIcon);
	        }
	      },
	      d: function d(detach) {
	        if (detach) {
	          detachBetween(raw_before, raw_after);
	          detachNode(raw_before);
	          detachNode(raw_after);
	        }
	      }
	    };
	  }

	  function HelpViewer(options) {
	    var _this2 = this;

	    init(this, options);
	    this.store = store_1();
	    this._state = assign(data(), options.data);

	    this._recompute({
	      pageTitle: 1
	    }, this._state);

	    this._intro = true;
	    if (!document.getElementById("svelte-1i1zwu1-style")) add_css();
	    this._fragment = create_main_fragment(this, this._state);

	    this.root._oncreate.push(function () {
	      oncreate.call(_this2);

	      _this2.fire("update", {
	        changed: assignTrue({}, _this2._state),
	        current: _this2._state
	      });
	    });

	    if (options.target) {
	      this._fragment.c();

	      this._mount(options.target, options.anchor);

	      flush(this);
	    }
	  }

	  assign(HelpViewer.prototype, proto);
	  assign(HelpViewer.prototype, methods);

	  HelpViewer.prototype._recompute = function _recompute(changed, state) {
	    if (changed.pageTitle) {
	      if (this._differs(state.showTitle, state.showTitle = showTitle(state))) changed.showTitle = true;
	    }
	  };

	  exports.HelpViewer = HelpViewer;

	  Object.defineProperty(exports, '__esModule', { value: true });

	})));
	});

	unwrapExports(helpViewer);
	var helpViewer_1 = helpViewer.HelpViewer;

	var name = 'prosHelpViewer';
	function prosHelpViewer() // Directive angular dependencies
	{
	  'ngInject';

	  var directive = {
	    restrict: 'EA',
	    scope: {
	      pageTitle: '=',
	      type: '=',
	      url: '=',
	      showSurvey: '=',
	      notFoundMessage: '=',
	      helpFeedbackQuestion: '=',
	      thumbsUpClicked: '=',
	      thumbsDownClicked: '='
	    },
	    link: helpViewerLink,
	    controller: helpViewerController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	  return directive; //////////////////////

	  function helpViewerLink(scope, element, attrs) {
	    var props = {
	      pageTitle: scope.vm.pageTitle,
	      type: scope.vm.type,
	      url: scope.vm.url
	    };

	    if (scope.vm.showSurvey != undefined) {
	      props['showSurvey'] = scope.vm.showSurvey;
	    }

	    if (scope.vm.notFoundMessage != undefined) {
	      props['notFoundMessage'] = scope.vm.notFoundMessage;
	    }

	    if (scope.vm.helpFeedbackQuestion != undefined) {
	      props['helpFeedbackQuestion'] = scope.vm.helpFeedbackQuestion;
	    }

	    scope.vm.helpViewer = new helpViewer_1({
	      target: element[0],
	      data: props
	    });
	    scope.$watch('vm.pageTitle', function (pageTitle) {
	      scope.vm.helpViewer.set({
	        pageTitle: pageTitle
	      });
	    });
	    scope.$watch('vm.type', function (type) {
	      scope.vm.helpViewer.set({
	        type: type
	      });
	    });
	    scope.$watch('vm.url', function (url) {
	      scope.vm.helpViewer.set({
	        url: url
	      });
	    });
	    scope.$watch('vm.showSurvey', function (showSurvey) {
	      if (showSurvey != undefined) {
	        scope.vm.helpViewer.set({
	          showSurvey: showSurvey
	        });
	      }
	    });
	    scope.$watch('vm.notFoundMessage', function (notFoundMessage) {
	      if (notFoundMessage != undefined) {
	        scope.vm.helpViewer.set({
	          notFoundMessage: notFoundMessage
	        });
	      }
	    });
	    scope.$watch('vm.helpFeedbackQuestion', function (helpFeedbackQuestion) {
	      if (helpFeedbackQuestion != undefined) {
	        scope.vm.helpViewer.set({
	          helpFeedbackQuestion: helpFeedbackQuestion
	        });
	      }
	    });
	    scope.vm.helpViewer.on('thumbsUpClicked', function (event) {
	      scope.$emit('thumbsUpClicked', event);
	      scope.vm.thumbsUpClicked();
	    });
	    scope.vm.helpViewer.on('thumbsDownClicked', function (event) {
	      scope.$emit('thumbsDownClicked', event);
	      scope.vm.thumbsDownClicked();
	    });
	  }
	  /** @ngInject */


	  function helpViewerController() // Controller angular dependencies
	  {
	    // Constants
	    // Variables
	    // View Model
	    var vm = this; //   VM properties
	    //   VM methods

	    vm.$onInit = onInit;
	    return; ///////////////
	    // Init

	    function onInit() {} ///////////////
	    // VM methods
	    ///////////////
	    // Helpers

	  }
	}

	var helpViewer_module = angular.module('printos.help-viewer', []).directive(name, prosHelpViewer).name;

	return helpViewer_module;

})));



//////////////////
// WEBPACK FOOTER
// ../~/@printos/angular1-help-viewer/dist/help-viewer.js
// module id = 81
// module chunks = 0